import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import ReactPlayer from 'react-player';

function Chat({ id, username, usershort, room, role, setShowChat, setRole, appState, setAppState, mouse, language, setLanguage, cursorFPS, setCursorFPS }) {
  
  const [eventState, setEventState] = useState('intro');
  const [overlay, setOverlay] = useState("false");
  const [overlayImage, setOverlayImage] = useState(0);
  const [scheduleVisible, setScheduleVisible] = useState(false);
  const [handleTitle, setHandleTitle] = useState("drag me!");
  const [heartList, setHeartList] = useState([]);
  const [ytPlayState, setYTplayState] = useState(false);
  // const [miceSettings, setMiceSettings] = useState();
  const [stateInView, _setStateInView] = useState('photo');
  const [themeInView, setThemeInView] = useState('photo');
  const [dragStart, setDragStart] = useState(0);
  const [playingAtDragStart, setPlayingAtDragStart] = useState(false);
  const [modal, setModal] = useState(1);
  const modalText = [
    "",
    "<p>On May 13, 2022 the KÜNSTLERINNENPREIS NRW 2022 was awarded to Nieves de la Fuente Gutiérrez and Joan Heemskerk.<br/>In a first-of-its-kind virtual event the audience could experience the ceremony and the laureate's work.</p><p>This page is a representation of this event. You can re-experience it chronologically or skip around on the timeline as you would in a video. Enjoy!</p>",
    "<p>This is the end of the virtual event re-experience.<br/>We hope you enjoyed it and would love to see you again next year!</p>"
  ]
  const [modalVisible, setModalVisible] = useState(1);
  const [bgMuted, setBgMuted] = useState(false);

  const messagesEndRef = useRef(null);
 
  // player related
  const playerRef = useRef(null); 
  const videoRef = useRef(null); 
  const videoBgRef = useRef(null); 
  const [videoUrl, setVideoUrl] = useState("https://storage.googleapis.com/kp22/heemskerk/joan-one-2000kbit.mp4");
  // const [videoBgUrl, setVideoBgUrl] = useState("./ppoensgen/ppoensgen-leveled.mp4")
  const [playing, setPlaying] = useState(false);
  const [playingBg, setPlayingBg] = useState(false);
  const setPlayingBg_ = (value) => {
    console.log('setPlayingBg '+value+' playingBg is '+playingBg);
    setPlayingBg(value);
  };
  const [progress, setProgress] = useState(0);
  const [savedProgress, setSavedProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const chapters = [
    { section: 'intro', start: 0, startText: 0, endText: 312, duration: 317, ref: '97126849-1c1d-4161-8992-e785c1d22866'},
    { section: 'greeting-1', start: 317, startText: 324, endText: 512, duration: 201, ref: 'cd114bc5-5b19-43be-b914-09e765ba9db9'},
    { section: 'greeting-2', start: 518, startText: 524, endText: 759, duration: 244, ref: 'bb547295-9c52-4b46-90f5-ff31d631e93d'},
    { section: 'laudatio-1', start: 762, startText: 773, endText: 1297, duration: 538, ref: 'beae7254-4d7f-4841-a389-b2bbf5cac061'},    
    { section: 'presentation-1', start: 1300,startText: 1309,endText: 1907, duration: 615, ref: '3e380142-d5fa-4499-8270-e4aeb7547a8b'},
    { section: 'dialogue-1', start: 1915, startText: 1932, endText: 2254, duration: 339, ref: '1967672d-9c2b-4a75-b752-f176529ca1f6'},
    { section: 'laudatio-2', start: 2254, startText: 2295, endText: 3070, duration: 818, ref: 'a1b67fde-e60b-4037-b096-17c973b0416c'},
    { section: 'presentation-2', start: 3072, startText: 3093, endText: 3759, duration: 687, ref: '59bab6ed-3eef-413e-88bd-b8b85d88128c'},
    { section: 'dialogue-2', start: 3760, startText: 3781, endText: 3942, duration: 186, ref: 'c9cd627e-4e52-4290-b6aa-d04737196805'},
    { section: 'exhibition', start: 3946, startText: 3973, endText: 4677, duration: 731, ref: '78ebe2c2-501c-4104-8421-e94656bfc47d'}
  ];

  const inlineImages = [
    { id: 0, type: 'image', speaker: 'hawranke', url: "" },
    { id: 1, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Caracaballo.jpg", keyword: "caracaballo" },
    { id: 2, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Lex-Wolf.jpg", keyword: "lex wolf" },
    { id: 3, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Mary-Higgins-Clark.jpg", keyword: "mary higgins clark" },
    { id: 4, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Non-Human.jpg", keyword: "non-human" },
    { id: 5, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Playfullness.jpg", keyword: "playfulness" },
    { id: 6, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Queen-Victoria.jpg", keyword: "queen victoria" },
    { id: 7, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Reliquia.jpg", keyword: "reliquia" },
    { id: 8, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Research.jpg", keyword: "research" },
    { id: 9, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Technology2.jpg", keyword: "technology" },
    { id: 10, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Work-Simulator.jpg", keyword: "work simulator" },
    { id: 11, type: 'image', speaker: 'hawranke', url: "https://storage.googleapis.com/kp22/hawranke/Bamboo.jpg", keyword: "bamboo" },
    { id: 12, type: 'image', speaker: 'theissen', url: "https://storage.googleapis.com/kp22/theissen/joan-heemskerk.jpg", keyword: "joan heemskerk" },
    { id: 13, type: 'image', speaker: 'theissen', url: "https://storage.googleapis.com/kp22/theissen/kuenstlerinnen.jpg", keyword: "women artists" },
    { id: 14, type: 'image', speaker: 'theissen', url: "https://storage.googleapis.com/kp22/theissen/symbolkraft.jpg", keyword: "symbolic power" },
    { id: 15, type: 'image', speaker: 'theissen', url: "https://storage.googleapis.com/kp22/theissen/nan-hoover.jpg", keyword: "nan hoover" },
    { id: 16, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/1_AE.jpg" },
    { id: 17, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/2_AE.jpg" },
    { id: 18, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/3_AE.jpg" },
    { id: 19, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/4_AE.jpg" },
    { id: 20, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/5_AE.jpg" },
    { id: 21, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/6_AE.jpg" },
    { id: 22, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/7_AE.jpg" },
    { id: 23, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/8_AE.jpg" },
    { id: 24, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/9_AE.jpg" },
    { id: 25, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/10_AE.jpg" },
    { id: 26, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/11_AE.jpg" },
    { id: 27, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/12_AE.jpg" },
    { id: 28, type: 'image', speaker: 'eckardt', url: "https://storage.googleapis.com/kp22/eckardt/13_AE.jpg" },
    { id: 29, type: 'image', speaker: 'ppoensgen', url: "https://storage.googleapis.com/kp22/ppoensgen/portraits.jpg" },
    { id: 30, type: 'image', speaker: 'ppoensgen', url: "https://storage.googleapis.com/kp22/ppoensgen/nieves-portrait.jpg" },
    { id: 31, type: 'image', speaker: 'ppoensgen', url: "https://storage.googleapis.com/kp22/ppoensgen/piotrowska-crop.jpg" },
    { id: 32, type: 'image', speaker: 'ppoensgen', url: "https://storage.googleapis.com/kp22/ppoensgen/PV_Dramaturgie.jpg" },
    { id: 33, type: 'image', speaker: 'ppoensgen', url: "https://storage.googleapis.com/kp22/ppoensgen/screenshot1.jpg" },
    { id: 34, type: 'image', speaker: 'ppoensgen', url: "https://storage.googleapis.com/kp22/ppoensgen/screenshot2.jpg" },
    { id: 35, type: 'video', speaker: 'heemskerk', url: "https://storage.googleapis.com/kp22/heemskerk/joan-one-2000kbit.mp4"},
    { id: 36, type: 'video', speaker: 'heemskerk', url: "https://storage.googleapis.com/kp22/heemskerk/joan-two-2000kbit.mp4"},
    { id: 37, type: 'video', speaker: 'heemskerk', url: "https://storage.googleapis.com/kp22/heemskerk/joan-three.mp4"},
    // { id: 38, type: 'video', speaker: 'nieves', url: "./ndlfg/nieves-01_1.mp4"},
    { id: 38, type: 'video', speaker: 'nieves', url: "https://storage.googleapis.com/kp22/ndlfg/nieves-01_1.mp4"},
    { id: 39, type: 'video', speaker: 'ppoensgen', url: "https://storage.googleapis.com/kp22/ppoensgen/ppoensgen-leveled-4000kbit.mp4"}
  ];

  const triggers = [
    { start: 347, end: 357, ref: 15 },
    { start: 368, end: 384,  ref: 12},
    { start: 391, end: 399, ref: 13},
    { start: 413, end: 423, ref: 14},
    { start: 825.40, end: 929.22, ref: 4},
{ start: 929.22, end: 965.65, ref: 8},
{ start: 969.13, end: 1027.13, ref: 4},
{ start: 1027.13, end: 1052.13, ref: 1},
{ start: 1113.77, end: 1179.60, ref: 4},
{ start: 1179.62, end: 1255.83, ref: 6},
{ start: 1255.85, end: 1295.58, ref: 5},
{ start: 1363.85, end: 1902.35, ref: 38}, // nieves
{ start: 3179, end: 3389, ref: 35}, // joan screencast 1 (q and q)
{ start: 3423, end: 3616, ref: 36}, // joan screencast 2 (errors), switch at 3495    
{ start: 3657.82, end: 3757.33, ref: 37}, // joan 3
{ start: 4007.65, end: 4017.58, ref: 16},
{ start: 4017.60, end: 4028.47, ref: 17},
{ start: 4092.57, end: 4120.45, ref: 18},
{ start: 4143.63, end: 4180.33, ref: 19},
{ start: 4180.35, end: 4206.43, ref: 20},
{ start: 4206.45, end: 4235.82, ref: 21},
{ start: 4273.82, end: 4307.88, ref: 22},
{ start: 4307.90, end: 4342.60, ref: 23},
{ start: 4342.62, end: 4385.52, ref: 24},
{ start: 4404.40, end: 4439.68, ref: 25},
{ start: 4468.25, end: 4487.48, ref: 26},
{ start: 4487.50, end: 4514.47, ref: 27},
{ start: 4555.22, end: 4588.73, ref: 28}
];

const hearts = [
  96.37,105.55,156.05,223.32,264.23,265.57,275.17,284.77,287.58,318.35,324.10,440.62,479.77,480.28,490.10,513.75,516.37,517.08,518.15,518.90,519.72,520.38,521.35,522.30,523.32,524.77,525.80,529.60,534.28,535.35,576.02,738.32,756.05,756.88,761.47,765.10,786.38,787.33,788.20,789.13,789.78,790.33,790.68,790.88,791.33,791.73,792.22,792.45,792.85,793.30,793.65,794.07,794.50,794.87,798.12,799.10,799.40,799.75,800.23,800.52,800.78,801.25,801.63,802.22,802.60,803.22,821.65,822.07,822.47,823.00,823.37,823.73,836.02,836.40,836.73,837.27,837.85,838.43,838.75,839.23,839.67,840.20,858.10,884.10,884.23,884.82,885.23,885.60,886.05,886.65,887.33,887.90,888.58,889.38,890.75,893.37,897.85,898.32,898.75,899.75,925.37,1029.87,1030.32,1030.63,1031.02,1031.48,1032.23,1032.67,1033.02,1033.35,1033.62,1033.87,1034.23,1034.52,1034.80,1035.38,1035.58,1037.70,1038.15,1040.15,1044.43,1044.78,1045.48,1046.12,1046.80,1047.35,1047.65,1048.02,1048.57,1048.87,1049.23,1049.52,1049.85,1050.27,1128.75,1129.37,1129.57,1159.10,1159.40,1163.55,1164.23,1169.85,1170.53,1171.12,1180.15,1180.67,1181.28,1181.77,1182.35,1182.72,1183.25,1183.63,1184.17,1184.78,1293.13,1293.55,1294.65,1301.07,1301.52,1301.78,1302.07,1302.40,1302.78,1303.18,1303.42,1303.72,1304.02,1304.27,1304.50,1304.77,1305.15,1305.45,1307.00,1307.83,1308.30,1309.42,1310.48,1313.03,1313.77,1314.23,1314.55,1315.00,1315.37,1315.90,1316.45,1317.30,1346.70,1363.17,1378.00,1378.73,1379.42,1385.82,1386.35,1386.78,1387.25,1387.62,1388.03,1388.38,1388.70,1389.08,1389.42,1389.72,1390.07,1390.42,1390.73,1391.22,1393.15,1394.42,1394.80,1395.43,1396.25,1396.72,1404.27,1404.77,1405.07,1406.03,1406.23,1406.48,1406.90,1472.65,1473.15,1473.43,1476.62,1538.70,1539.20,1567.55,1567.85,1573.28,1573.63,1604.37,1604.72,1605.22,1605.62,1606.15,1616.58,1617.07,1617.55,1618.13,1619.55,1620.05,1628.50,1629.00,1629.90,1630.48,1631.27,1662.53,1715.75,1716.20,1716.60,1717.23,1832.73,1894.13,1894.52,1894.90,1901.57,1908.28,1908.60,1909.32,1909.72,1911.00,1911.47,1911.85,1912.37,1912.77,1915.13,1915.50,1915.85,1916.35,1916.88,1917.40,1917.78,1918.32,1918.73,1919.22,1919.63,1920.20,1920.62,1922.53,1923.15,1924.68,1925.12,1933.15,1933.52,1934.10,2007.10,2007.37,2007.75,2008.20,2008.57,2009.02,2009.40,2009.78,2010.23,2010.62,2011.08,2011.43,2011.82,2013.12,2013.70,2021.00,2021.67,2022.33,2023.00,2023.60,2075.82,2076.50,2077.02,2078.75,2101.63,2213.62,2246.20,2246.53,2247.52,2248.25,2248.58,2248.88,2249.30,2249.73,2250.15,2250.47,2250.80,2251.18,2251.50,2251.87,2252.25,2252.73,2253.23,2260.25,2260.58,2261.18,2261.53,2263.78,2475.12,2477.40,2478.40,3077.23,3077.87,3078.10,3078.40,3078.70,3079.03,3079.37,3079.67,3080.07,3080.32,3080.80,3128.23,3128.65,3657.13,3756.57,4037.10,4040.77,4041.67,4286.32,4287.83,4288.10,4288.20,4288.73,4289.13,4289.47,4289.78,4290.18,4290.47,4290.82,4291.33,4300.05,4300.40,4300.88,4301.72,4405.27,4405.68,4406.27,4409.27,4605.43,4605.77,4606.22,4606.63,4607.08,4607.40,4607.72,4608.12,4608.50,4608.85,4609.27,4609.53,4609.83,4610.20,4610.52,4610.70,4611.05,4611.33,4612.05,4614.23,4615.15,4615.57,4616.18,4616.80,4617.60,4618.27,4618.58,4619.43,4620.28,4621.12,4626.73,4627.20,4627.58,4628.05,4628.72,4630.13,4630.48,4630.75,4631.15,4631.47,4631.82,4632.48,4633.02,4633.37,4633.68,4634.17,4634.52,4635.03,4635.53,4636.00,4636.42,4637.10,4637.80,4640.83,4641.25,4641.60,4642.63,4643.52,4643.82,4644.12,4644.33,4644.55,4644.78,4645.17,4646.18,4646.52,4646.87,4647.30,4647.73,4648.17,4648.63,4649.12,4649.63,4654.57,4655.22,4655.57,4656.00,4656.35,4656.72,4657.35,4657.88,4659.10,4659.73,4660.18,4661.27,4661.70,4662.10,4662.47,4662.80,4663.25,4663.58,4664.05,4664.42,4664.75,4665.17,4665.43,4665.65,4669.35,4669.63,4669.88,4670.20,4670.48,4670.77,4671.15,4671.62,4671.87,4672.37,4672.75,4673.12,4673.37,4673.58,4673.83,4674.15,4674.55,4675.17,4675.50,4676.47,4676.68,4677.08,4677.35,4677.62,4677.88,4678.43,4678.80,4679.28,4679.58,4679.80,4680.23,4680.65,4681.07,4681.25,4681.53,4681.80,4682.18,4682.52,4682.73,4683.07,4683.40,4683.73,4684.13,4684.45,4684.67,4684.90,4685.28,4685.53,4685.83,4686.20,4686.48,4686.75,4687.10,4687.35,4687.62,4687.88,4688.45,4688.78,4693.25,4694.35,4695.02,4695.47,4696.18,4696.63,4697.22,4697.57,4697.87,4698.30,4698.65,4699.15,4699.68,4701.57,4702.37,4704.83
];

  const transcript = [
    {
    "id":"97126849-1c1d-4161-8992-e785c1d22866",
    "uid":"7KOpYqATRTCEjyg8AABD",
    "username":"Isabel Pfeiffer-Poensgen",
    "usershort":"IP",
    "type":"message",
    "interim":"",
    "final":"verehrte Preisträgerinnen Frau Heemskerk und Frau de la fuente Gutierrez Preußen sehr verehrte Damen und Herren ich begrüße Sie herzlich zur Verleihung des künstlerinnenpreis ist Nordrhein-Westfalen bereits seit 1997 zeichnet das Land herausragende künstlerische Leistungen von Frauen aus Ziel ist es die Präsenz von Künstlerin in den unterschiedlichen Kunstsparten zu stärken die Besonderheit des Preises liegt aber nicht nur in seiner langen Tradition sondern auch in den immer wechselnden Disziplinen mit der heutigen Preisverleihung sind es bereits 22 verschiedene Bereiche in denen wir ihnen vergeben haben heute verleihen wir den Künstlerin Preis für besondere Leistungen in den digitalise Halle und zeitbasierte Medien bestimmen die informations Kreisläufe des 21 jahrhunderts die fortschreitende Digitalisierung der Gesellschaft bringt einen umfassenden technologischen und kommunikativen Wandel mit sich die Corona Pandemie hat diesen Prozess noch beschleunigt Kunst und Kultur in Zeiten der Digitalität ist auch für das Land nochmals fallen ein zentrales Kultur politisches Thema die Digitalisierung als wichtige Treiber rin hat in der Kunst neue Produktionsformen Geschäftsmodelle Wertschöpfungsketten und Wege der Präsentation und Vermittlung hervorgebracht erreichen Förderprogramm in diesem Bereich aber vor allem auch vielen engagierten Akteurinnen und Akteuren sind wir in Nordrhein-Westfalen sehr gut aufgestellt lassen Sie mich einige Beispiele nennen das medienwerk NRW als wichtiges Netzwerk für Medienkunst und digitale Kultur wie für Theater und Digitalität mit der 2019 ein Modellprojekt für digitale Innovationen im Bereich der darstellenden Künste ins Leben gerufen wurde oder den Hardware MedienKunstVerein der sich seit 1996 als international renommierte Plattform für zeitgenössische Medienkunst im Zusammenspiel von Kunst Gesellschaft und Technologie widmet und auch zwischen Forschung und Kunst gibt es mit dem innovationshub Düsseldorf eine interessante Vernetzung hier werden in einem interdisziplinären Team digitale Projekte umgesetzt von denen zahlreiche in Kooperation mit Kultureinrichtung Künstlerinnen und Künstlern entwickelt worden liege flach Lichter auf das was in den Titel Arzt in Nordrhein-Westfalen passiert besonders die digitalen Künste entwickeln sich gerade so dynamisch weiter wie kaum eine andere Kunstform es ist daher sinnvoll dass wir in diesem Jahr die digitalize als Schwerpunkt des Künstlerin Preises gesetzt haben und heute 2 in diesem Feld impulsgebende Frauen auszeichnen können während zwei Künstlerinnen die den digitalen Wandel mitgestalten und für einen unkonventionellen Blick und reflektieren und Umgang mit digitalen Technologien stehen dir jumpscare quien Jervis de la fuente Gutierrez you works convey the political attitude that is characterized by curiosity conceptual springs and with each in very different Ästhetik ways I congratulate you on receiving the sword looking forward to the introductions to your artistic practices ich möchte allen danken die an der Auslobung und Verleihung des 22 künstlerinnenpreis mitgewirkt haben an erster Stelle den Jury Mitgliedern deren Expertise wir die hervorragende Wahl zu verdanken haben dem frauenkulturbüro dass das Ausschreibungs und Auswahlverfahren sowie die Preisverleihung wie gewohnt professionell organisiert hat der Künstlerin und Kuratorin Anke Eckardt wie das frauenkulturbüro fachlich beraten hat und aktuell die digitale Ausstellung der beiden Preisträgerin vorbereitet und der Kunstsammlung Nordrhein-Westfalen die wie schon bei der ersten Verleihung 1996 Kooperationspartnern des Preises ist meine sehr verehrten Damen und Herren bereits zum 22 Mal wird dieser Preis vergeben aber zum ersten Mal findet die Preisverleihung digitalstadt in Pandemie Zeiten haben wir uns an diese Form des Zusammenkommens schon mehr oder weniger gewöhnt die letzten zwei Jahre haben viele neue und interessante digitale Veranstaltungsformat hervorgebracht die auch künstlerische Prozesse beeinflusst haben ich bin sehr gespannt was uns in dieser Hinsicht heute noch erwartet und wünsche uns allen insbesondere natürlich den beiden Preisträgerinnen einen interessanten Abend",
    "state_event":"intro",
    "color":"vier",
    "assoc":"ppoensgen",
    "start": 0,
    "duration": 312
  },{
    "id":"cd114bc5-5b19-43be-b914-09e765ba9db9",
    "uid":"s08UtVyW2G8xP7aIAAF_",
    "username":"Ursula Theißen",
    "usershort":"UT",
    "type":"message",
    "interim":"",
    "final":"is the director of the women's council office I would like to work on your very warm ready to this evening and a reminder right away the first female artist prize was awarded in 1996 in the category of new media media art in Prize winner Nan hoover unfortunately already passed away was one of the pioneers of international Light review and performance at since then the female artist prize was awarded in many other Fields the works of our today's main laureate John hibs-celtic were created of an even longer time period John Haynes Kirk is considered to be one of the formative pioneers of digital art whose current works continue to be perceived as groundbreaking prices of worded to direct the public focus on the artistic work of women women artists are still underrepresented there's a big dinner show gap and pay gap on the ad market in galleries and museums and altering the major prices in this respect the female artists of what 20-22 for digital art has strong symbolic power create visibility for female artists of the art and furthermore promotes the Award winners in a noninstitutionalized Fiat at this point congratulation to the two pipes Brothers John Haynes Kirk and Nevis delafuente retailers I like to thank thanks to the minister of culture and science Mrs £5 for the fact that her institution has been awarding the state prize for women artist for so many years and that she has taken on this experiment as the first digit Award ceremony the great Yuri Diana McCarthy and livian Alaska glaciers formed the preliminary Julie the main Julie another shaman ship of Diana McCarty Douglas Kristoff and span heart or your lialina and Monica Kirkman selected our toward winners with verse from a multitude of applications and Europe white nominations thanks also to all the artists who replied in the nominators who made proposals for the award I like to thank the study of monkeys and the studio on your analogue without whom we would be sitting in a very normal live stream event today and would not be able to be excited about the things to come as we are now thank you",
    "state_event":"greeting-1",
    "color":"drei",
    "assoc":"theissen",
    "start": 324,
    "duration": 188
  },{
    "id":"bb547295-9c52-4b46-90f5-ff31d631e93d",
    "uid":"fcHJlmZCdAVKVPpDAAEz",
    "username":"Diana McCarty",
    "usershort":"DM",
    "type":"message",
    "interim":"",
    "final":"evening welcome and thank you for creating and continue in this prize thank you and it's a good work yes we have a long way to go but if this is a wonderful process could be part of just want to say that over 21 League 21/22 odds for the female artist award 2022 and we received over 60 applications for the sponsorship award which was coated onto the preselection and spend a lot of time and I think it was a wonderful very fair process where we were able to look into that was making the work what was what was contemporary about an actual how did it how was Media expanded by or the notions are working with a very wonderful couple of rounds of process and really wonderful discussions satisfied with the selection so but powerful work started around that's the time the other orders was getting born selected because of their actual work and how it expanded media and perceptions of art it was exciting to see a fresh body of work and how she is holding her skills as a media artist really worthy of support and recognition we is the jury felt that she had worked hard to make art that can communicate across fields and disciplines in a way that is worthy of the sponsorship award we really hope the disc hope you continue making powerful contemporary art regulations really worked for and then who would be able to bring the benefit from it and hopefully this is one of the things it a price like this can do is an order as well on her way and working very hard with further success place of Joan there were many arguments to award her with the main prize of female artist in digital art never stop being fresh and tiring it's always operating outside of what is contemporary art or even Media hard to communicate exactly what needs to be communicated in that mode it is always timely it is always authentic and it continues to be actual finally as many many people know Jean Harris Kirk from her work with Jodie day at work and you're pregnant featured or recognised or even mentioned for her contributions to contemporary art in digital art and media art or even that hard as a female artist I just want to eat for my powerful contemporary art is because he is not going to stop the word is really as long as they do I'm delighted to be a part of the group that can make this happen and I also want to say like from myself thank you for your practise in your support of other women artists and congratulate you",
    "state_event":"greeting-2",
    "color":"funf",
    "assoc":"mccarthy",
    "start": 524,
    "duration": 244
  },{
    "id":"beae7254-4d7f-4841-a389-b2bbf5cac061",
    "uid":"6sBUr-Fbk4mSneW2AADz",
    "username":"Thomas Hawranke PhD",
    "usershort":"TP",
    "type":"message",
    "interim":"",
    "final":"there was another Tyson Fury the audience and most importantly dangerous to tell you something about the artist research a critical thinker and take which nearest elephant to potatoes and I'm doing this because I have known you for quite some time I experienced many of a fantastic art projects and with one of our conversations on topics such as transfer manatee gender about our relationship to non-human animals the real and virtual and so on and this story I want to tell you guys like this at the call never sad practise is transmedia she works with clay paint marks all kinds of biological fluids code and microcontrollers Digital Play and variety of Media Production tools turn off news digital environments you can feel the connection between her creation and the world and material materiality that Lies Beneath think about world building a something in the scent of music practise you always feel the gestures of scattering painting and the placement of objects information and interactions within the special situation exploring and experiencing these trails laid out by the authors have highlighted aspects to understand and perceive neighbours work as a participant of a work you have to feel those materials through the vicinity of your own body at the same time neighbours work is highly informed by theoretical Concepts for example territory relationship by Jorge Luis borges she's this extensively in insulation ridiculous because then there is done a herbicid about responsibility and intraspecies communications theories about virtual world's and the tribes such a slow typer syrup used and tell Taylor I even up solid series and knowledge like for example measurement systems of Beauty bag for push-along this theories are combined with own experience forming a special Kind of data corpus that encompass academic with embodied and tested forms of knowledge in her empirical data she makes precise observations take samples from the field to analyse writes about subjective access to a specific field in her diary and someone and practise as research based name not only to reflect on Theory but rather to digested by putting the process of knowledge creation into the centre of the reception of her work and in doing so Theory becomes a statically experience of transferring knowledge into events for our sensorial apparatus I will Focus now on two aspects and never to work the non-human and the playfulness and I will do this by referring to two projects who developed the last couple of use at the threshold of technology emancipated at practise and the historical and social sphere of the everyday ok by you which translate horseface is a sculpture that combines aspects of the human and the non-human it is based on the measurement system for perfection developed by cloud bushel.and the Field of classic baroque equestrianism and 8s a connection to the beauty ideal associated to femininity at this time what's the weather play nervous motion 3D data from a generic horse model with the scan of our own head then the cost and filled this mode with wax for finest Catch Up was mounted on a pole like a the presentation of abrupt past that Ideal of Beauty associated both with women and Horses and the objective functions through the male gaze counter narrated with the object we encounter in the exhibition space and I will try to pick up the image the form is a grotesque and I got nation of two symbols of Beauty which in the message from do not refer to the ideal of Barack representation but rather its own unique transform a trans human form of beauty the gesture of assembly to deconstruct common understanding of something and to render an alternative perspective on beauty femininity the human and the non-human as a driving Force behind neighbours work Alexa wolf this assemblage includes political text the urine of wolves and headphones with ears attached to them the audio tells us the lively story of alone for a she-wolf who speaks about border and bottled e-frontiers the mobile sedation of the audiobook is accompanied by objects and exhibition space and the scent trail laid out in the open space this invisible trace that's another component to nervous work the playfulness much like a game of scavengers Hunt need this prayers the urine of wolves at different locations locations for docks pigeons cats backs places for animals non-places for your mum's by addressing both territories neighbours also proposed to include different modes of perception within our practise some aspects and it was work out for human animals are those for non-human animals and some of footballs Riverside practise as part of our world it is not exclusively addressing one aspect but tries to combine different location territories social and cultural spheres when you are in one of the Universe VR worlds you can feel the red sand of those the planet Mars and the open pit mine in southern Spain and they're chose this specific insulation is called no service on Sunday and Queen Victoria's birthday it's the translation at The Originals in Spain and it's not only entangled the real and virtual but also empirical and autobiographical data 3D geometry and Topographic information body and mind is interest in the world comes from a perspective that are compatible cific forms of care that we is artists have in fact the right to a say in the metal voice matter elections matter play isn't doing what we want but doing but we can with materials we found along the way and isn't the experience of pleasure but the outcome of tinkering with a small part of the world in a surprising way this quotation by North American philosopher Ian Burrows reflects not only on play in The Magical circle but rather implies that playfulness is a general mode in dealing with the world when we celebrate Nevis practise today a fantastic projects a passion for the Arts within witness someone who steeply concerned with our world and she confronts the struggle of being in this highly unbalanced World by acting out in a playful way did Yuri thanks for giving this one of the price to nearest elephant to potatoes have chosen artist who reflect equal opportunity profoundly in her work was a strong and Wise women's rights who is directions to give us hope that our future will be shaped more and more other similar voices idp hope this and the price today is a strong step in this Direction universe it is my honour to tell you this in the most profound way you deserve this I deeply hope that the future will shout out your name into this world that we all witness you entanglement with ongoing struggle that life and tails and that your practise will accompany us and give us multiple perspectives on things we thought we already know that is all celebrate you today and how many days that will come under regulations",
    "state_event":"laudatio-1",
    "color":"drei",
    "assoc":"hawranke",
    "start": 775,
    "duration": 523
  },{
    "id":"3e380142-d5fa-4499-8270-e4aeb7547a8b",
    "uid":"srlcO4n7H6t_JQvUAAD7",
    "username":"Nieves de la Fuente Gutiérrez",
    "usershort":"NG",
    "type":"message",
    "interim":"",
    "final":"thank you very much for your kind words to my sis amazing thank you thank you very much thank you for the URI and thank you for little between tonight I wanted to give you a little to work inside of a digital world I created tenable and is called is related to the piece that Thomas mention before it no that's the retailers Domingos and Victoria so translate it no service or service unavailable on Sunday so I think Queen Victoria's birthday so I'm actually now my HTC goggles and I'm going to give you a tour I chose to show you this project because it's kind of open a line of work in my practice afterwards and it's installation I the perspective so maybe you can you have it fresh in front of your eyes I come by it's an investigation about an all mining Complex in the South Cerney of in the south of Spain where their family of my mother comes from and I combine and installation with the virtual reality simulator or work so somehow I collected samples and the smiling complex and these samples are connected to sensory and the sensors are microcontrollers creating some kind of accent reaction effects in the virtual reality landscape but the people inside his landscape don't have a clue so because of my relationship with the space and because I'm this landscape and because this landscape is going to be really important for me afterwards and also reading button for me for the work and develop in before that is good I wanted to give you an inside and a preview or not but I'll give you a tour of these landscape why it's important for me so I hope that now you can see the place and I put on my Google's soon as I told you this place or this digital landscape is based on the real landscape in the place my mum comes from and I was spending their Summers a lot of time so a lot of days and months in summer and then I moved to Germany and after years I realise how important and really strange landscape is so I kind of wanted to make like twins encapsulated for me to have like an archive of This Changing space and I started doing 3D skins of that and create dad is going to be like a collage of this important uses of the Stella and so I did this please and now we're standing here and this is the virtual or the other part of the insulation I show you before and since he's also I mean it's a landscape of memories no for me but this is also a very specific and special landscape because is an open pit mining landscape so it is transformed almost every day depending on the needs of the market and the prices of the minerals that are used for the industry and use for Informatics for building computers and everything so and it's been for a long long period of time that this has been active for a long period of time so this change is a lot so if you don't know how can you buy you start taking out material from the top of the mountain and you get the Colosseum and what do you do in one throw it away and so the minerals and they're that is supposed to be underneath cost to the top and create some kind of different topography befriend mountains and that's the Fascination that I mean this is a fascinating fascinating is me of this place and so it is also I want to sell you one of the text excerpts which are not to talk when I show you so every social documentaries so I interview different people of the space of his place of his village and the Prisoner of the archive and archaeology and ask them I will do a relationship with two with his landscape and this is also a really bad Ireland landscape I mean if you go there you are almost like walking on top of like wish I don't know how do you say in English but it's like I really stinky mineral and it's like you are working working and so this is like a changing Landscape it changes all the time so you relate to that is like the Bible memories to buddies changing all the time so this number is attending this change in everything's changing so in this piece objects are like part of his documentation to answer a simple I just want to tell you a story of plant these plants we are now on the Italian word the Reds on the shore of the red river that flows in the spirit as a really special and I told you before or afterwards why but this river is the plant called in the film did it and it's not exclusive is not endemic of this place but it has a really special behaviour here and it made me realise so inside of its tissue creates like a mineral and this is cold outside and you're outside is awesome but that's not really do this minute station project process in other parts of the work but here yes and create this kind of Martian meaning of stone and he's obviously I'm gonna tell you stories about this place when you put them up pick them up and say one and the last word I want to show you because I don't want to extend a take out a time is this like the coolest cities were married but will move when other people were people outside in The Galleria gonna work in front of the senses and this is a reference about the investigations that NASA is developing is 2 in in this area and other space agencies like the Spanish NASA interpret sample they are interested in because of his like amazing know the way it looks but also because of the properties of the soil and also for example for these bacteria that is living in this in the red river flows that this in the area of this pellets because this serious able to leave in a in water with a PH value of 2.5 with 3 acidic and with a low level of oxygen soon as I thought if you leave if these bacteria could live here to be may be related to the bacteria that's good have lived in Mars if we discover that is sleep in my life in March or not that's nothing that fascinating fascinating me most about this that NASA is going to my bed to do it do research in order to better what happens in Mars and maybe to colonize Mars and maybe two to terraform Mars so modified in order to make it habitable for humans when we have to leave Earth because we cannot live there anymore and it's happening here in this can of Simulation of order of mass on Earth so we have Morris forms this territory and made it makes him special that also some kind of style so I will leave it here because I can talk a lot and you move it I stop",
    "state_event":"presentation-1",
    "color":"vier",
    "assoc":"ndlfg",
    "start": 1313,
    "duration": 585
  },{
    "id":"59b21973-095c-4263-b907-c42d56a5dd78",
    "uid":"srlcO4n7H6t_JQvUAAD7",
    "username":"Nieves de la Fuente Gutiérrez",
    "usershort":"NG",
    "type":"message",
    "interim":"",
    "final":"yeah thank you very much",
    "state_event":"dialogue-1",
    "color":"vier",
    "assoc":"ndlfg",
    "start": 1903,
    "duration": 1
  },{
    "id":"1967672d-9c2b-4a75-b752-f176529ca1f6",
    "uid":"6wFqm-hBUo0sTQHMAADV",
    "username":"Anke Eckardt",
    "usershort":"AE",
    "type":"message",
    "interim":"",
    "final":"so what we can do now is asking questions",
    "state_event":"dialogue-1",
    "color":"funf",
    "assoc":"eckardt",
    "start": 1933,
    "duration": 5
  },{
    "id":"b7977854-16b8-417b-a4e9-b380d5ff77e2",
    "uid":"-CAS08aatST_8ik2AACr",
    "state_event":"generic",
    "username":"Lara RCZ",
    "usershort":"LR",
    "type":"question",
    "interim":"",
    "final":"is the place open to visitors, or is it a dangerous space?",
    "time":1652467043828,
    "start": 1940,
    "duration": .2
  },{
    "id":"ada67d8b-23f2-4aa5-9a21-3b5b0b0201d7",
    "uid":"srlcO4n7H6t_JQvUAAD7",
    "username":"Nieves de la Fuente Gutiérrez",
    "usershort":"NG",
    "type":"message",
    "interim":"",
    "final":"hi it's open to visitors it's not a dangerous space but now I mean it's going but I can force the domain was open and then was sell as it was open and close the planning of their prices of copper for example and so some areas that they have scanned closed to the public because they are owned by the next factory Enterprise that are taking the mirrors out it's not dangerous I mean the river is not perfect you shouldn't go and trim in this river and he stinks",
    "state_event":"dialogue-1",
    "color":"vier",
    "assoc":"ndlfg",
    "start": 1945,
    "duration": 50
  },{
    "id":"d2e415a0-1963-40d7-bedd-815a3626b1a9",
    "uid":"-CAS08aatST_8ik2AACr",
    "state_event":"generic",
    "username":"James",
    "usershort":"J",
    "type":"question",
    "interim":"",
    "final":"WIll this project ever be finished? Or is it an evolving, growing world?",
    "time":1652467120231,
    "start": 1996,
    "duration": .2
  },{
    "id":"f8deb680-c436-4662-ba4c-aec07e3886b6",
    "uid":"srlcO4n7H6t_JQvUAAD7",
    "username":"Nieves de la Fuente Gutiérrez",
    "usershort":"NG",
    "type":"message",
    "interim":"",
    "final":"yeah it's kind of growing and growing all the time that's was the first with this I started becoming interested about this and then I have created another installation and it was so the publisher of a book with polishing and it's going to be a word of that also in peace I'm going to show in June so I think it's evolving and it's getting more Martian more from others please",
    "state_event":"dialogue-1",
    "color":"vier",
    "assoc":"ndlfg",
    "start": 2019,
    "duration": 21
  },{
    "id":"ee1dca60-d27d-459c-b0e5-d9ed5bd23d0b",
    "uid":"-CAS08aatST_8ik2AACr",
    "state_event":"generic",
    "username":"Tessa knapp",
    "usershort":"TK",
    "type":"question",
    "interim":"",
    "final":"dear nieves, could you explain the process of scanning - did you scan the whole area or reconstruct it from details ... ? ",
    "time":1652467176814,
    "start": 2071,
    "duration": 1
  },{
    "id":"5dba60b3-d8dc-4df3-b60f-eab2d12099b1",
    "uid":"6wFqm-hBUo0sTQHMAADV",
    "username":"Anke Eckardt",
    "usershort":"AE",
    "type":"message",
    "interim":"",
    "final":"Nevis do you see differences between the digital landscape the 3D landscape and the analogue one and if so how do they differ",
    "state_event":"dialogue-1",
    "color":"funf",
    "assoc":"eckardt",
    "start": 2072,
    "duration": 16
  },{
    "id":"02eb349a-2c24-44eb-a56d-49400ad88501",
    "uid":"srlcO4n7H6t_JQvUAAD7",
    "username":"Nieves de la Fuente Gutiérrez",
    "usershort":"NG",
    "type":"message",
    "interim":"",
    "final":"yeah of course differences I mean of course indestructi not and but the thing that I like about this 3D Peter landscape maybe I can put the both of them 3D scans and 11-in into different groups the thing I like of this digital landscape is like for me is something I can it's really multiple so I can transform it I can put pieces together that doesn't belong together and create my own and more fit and transformer is like like flower like Floyd somehow and the thing that is funny about this kind of analogue landscape because it's also really",
    "state_event":"dialogue-1",
    "color":"vier",
    "assoc":"ndlfg",
    "start": 2089,
    "duration":60
  },{
    "id":"ae90b5c7-9117-460e-a300-c96785ed9e40",
    "uid":"srlcO4n7H6t_JQvUAAD7",
    "username":"Nieves de la Fuente Gutiérrez",
    "usershort":"NG",
    "type":"message",
    "interim":"",
    "final":"in transformation in a really short term so it's from day today if it changes almost like I don't know if you can say that way you can think it's like like this and multiple",
    "state_event":"generic",
    "color":"vier",
    "assoc":"ndlfg",
    "start": 2150,
    "duration": 20
  },{
    "id":"072f8cf0-5df4-47e0-9627-0adebae3986a",
    "uid":"-CAS08aatST_8ik2AACr",
    "state_event":"generic",
    "username":"Tessa knapp",
    "usershort":"TK",
    "type":"question",
    "interim":"",
    "final":"dear nieves, could you explain the process of scanning - did you scan the whole area or reconstruct it from details ... ? ",
    "time":1652467176814,
    "start": 2175,
    "duration": .2
  },{
    "id":"ae90b5c7-9117-460e-a300-c96785ed9e40",
    "uid":"srlcO4n7H6t_JQvUAAD7",
    "username":"Nieves de la Fuente Gutiérrez",
    "usershort":"NG",
    "type":"message",
    "interim":"",
    "final":"yeah I tried to scan the whole area I didn't with a single camera was 2015 I use for the grammar tree so you recreate A3 landscape",
    "state_event":"generic",
    "color":"vier",
    "assoc":"ndlfg",
    "start": 2177,
    "duration": 18
  },{
    "id":"9fd6b3c7-4452-4dd6-a82e-56c6be02f947",
    "uid":"RfSs21Z11JrmgJsoAAK2",
    "username":"Diana McCarty",
    "usershort":"DM",
    "type":"message",
    "interim":"",
    "final":"",
    "state_event":"dialogue-1"
  },{
    "id":"98abce47-6c24-4237-85ab-d011d3877263",
    "uid":"srlcO4n7H6t_JQvUAAD7",
    "username":"Nieves de la Fuente Gutiérrez",
    "usershort":"NG",
    "type":"message",
    "interim":"",
    "final":"relying on the information of photography and of course in this process because was one of the first products I did with it got a little bit rough so I need to clean parts and say one bad is like a patchwork landscapes so I can buy in and I think you can see it at the Beginning pretty good so I combined patches of areas together that worked that where you Sybil was out of material that was not used thank you for your question",
    "state_event":"dialogue-1",
    "color":"vier",
    "assoc":"ndlfg",
    "start":2194,
    "duration": 47
  },{
    "id":"a1b67fde-e60b-4037-b096-17c973b0416c",
    "uid":"6wFqm-hBUo0sTQHMAADV",
    "username":"Anke Eckardt",
    "usershort":"AE",
    "type":"message",
    "interim":"",
    "final":"any more questions loaded soon Josephine are you there",
    "state_event":"laudatio-2",
    "color":"funf",
    "assoc":"eckardt",
    "start": 2252,
    "duration": 45
  },{
    "id":"54d4bc54-1c74-4317-9733-342e9877af02",
    "uid":"7qpmfH5BAG4AOU_WAAD9",
    "username":"Josephine Bosma",
    "usershort":"JB",
    "type":"message",
    "interim":"",
    "final":"yes I'm here but I thought I was up at 9:10 time am I on now",
    "state_event":"laudatio-2",
    "color":"eins",
    "assoc":"bosma",
    "start": 2300,
    "duration": 9
  },{
    "id":"aada0000-0b85-473f-bcaf-330ee03f9e19",
    "uid":"6wFqm-hBUo0sTQHMAADV",
    "username":"Anke Eckardt",
    "usershort":"AE",
    "type":"message",
    "interim":"",
    "final":"",
    "state_event":"dialogue-1",
    "color":"funf",
    "assoc":"eckardt"
  },{
    "id":"25339610-5465-444d-b4ad-238acd54f11b",
    "uid":"7qpmfH5BAG4AOU_WAAD9",
    "username":"Josephine Bosma",
    "usershort":"JB",
    "type":"message",
    "interim":"",
    "final":"",
    "state_event":"generic",
    "color":"eins",
    "assoc":"bosma"
  },{
    "id":"32339e8a-ccb4-4285-9fd8-f9efc36ac46e",
    "uid":"6wFqm-hBUo0sTQHMAADV",
    "username":"Anke Eckardt",
    "usershort":"AE",
    "type":"message",
    "interim":"",
    "final":"yes please",
    "state_event":"laudatio-2",
    "color":"funf",
    "assoc":"eckardt",
    "start": 2309,
    "duration": 1
  },{
    "id":"f4f97238-af10-4ea4-a9de-7864738d53d2",
    "uid":"7qpmfH5BAG4AOU_WAAD9",
    "username":"Josephine Bosma",
    "usershort":"JB",
    "type":"message",
    "interim":"",
    "final":"sorry I didn't realise location thank you it is my pleasure and privilege to give this location to John Holmes Kirk one of the most talented and humble artists I know John Hayes Kirk's early years read like a tourist guide to the Netherlands she was born a Stones throw from the fairy tale amusement park that efteling in cats evil and grew up in the bullet snake the flower bolt region where her father use computers to improve the cultivation of plants in greenhouses in the 80s is she was inspired by this or not Joan showed inquisitive mindset around computing from when she was young after finishing her tasks she would regularly make computers crash in school while quote trying to find out what else these machines could do and quote her brother wouldn't let her anywhere near his game computer designer doll any dogs not only illustrates Jones deep-rooted Curiosity and enterprising spirit it also reveals an intuitive inside that digital technologies potentially have far more applications than manuals and Industry would have us believe surrounding us with quickly become a prison if not for people like John showing us its walls and rules are fluid despite early explorations of the computer John Haynes Kirk first studied photography and the st. Joseph's Academy in braids are getting her ma at the academy in rush Christin 1990s to discover digital technologies when fellow students pointed her to Photoshop it made her switch from photography to digital media classes here she would meet her partner fast months and Belgian video artist the couple initially produced cd-roms they decided to set off for Silicon Valley to learn more about digital technologies in 1995 at the Gala laboratory for new media at San Jose State University they first discovered the world wide web and jodi.org was born it is nearly impossible to accelerate the influence the work of Jodie had on the development in arts in the context of the internet since then where first traditional graphic design rule to the desktop now the Deep Space of even a single webpage was discovered we're first there was the order of the library now there was an unexplored vast universe before the new Millennium Jody changed how we see the web instead of using the web as a portfolio space Jodie used it as a multidimensional canvas and material playing with different layers of the web browser and with elements of the code making up the web he was a work of art that did not appear on the web but in and through it this plus Jodie's bold use of colours pixelated shapes and code infested with made for a mind-blowing visual experience that would inspire artists and designers around the world to this day since then Jodie relentlessly continued exploring barriers at aspects of computer cultures to make art and I need to keep speaking about this partnership for a bit because it is so crucial in Jones internet is a constant presence even when in specific pieces only in the background there were several major our prices among which the pre-med art and was exhibited in numerous institutions around the world bus in media art institutions and in contemporary art spaces there is still the famous gap between those however the most critical cultural environment for the Artists is still the network Jean Haines Kirk and their passports share a love and respect for the internet inspired by the NT institutional and authoritarian approach to art and Culture find exploration deconstruction and reconfiguration of technology and electronic Media to them is the ultimate path to freedom in today's information Society even if both artists recognise the Narrow Maze the internet has become and going off grid can a x be necessary mentioning the significance of the network to Jody brings me to what I think has been a misinterpretation of the work of John Hayes Kirk and apartments by some critics his work has been called formalist and modernist through and through as if with this work we returned to times when art was solely concerned with the medium art for arts sake and little more what is refusal to take on a clear-cut media activist profile might be confusing you to understand that any deconstructive or subversive work with media technology is always critical by default Media technology is a contested space in which politics are hidden in Technics forever and white with it runs are aware of this issue their work is not solely aimed at exposing it that's against it industry standards and what we could call Tech manual culture makes each of the Works revelatory that is an entirely different art for the sake of art where the Artists forward no room for art and Culture to continue to develop not disclosing aspects of culture and Society We didn't even recognise as problematic before speaking about Jones solar work I have to say a few more words by Judy as a partnership research shows that the reception of work by heterosexual artist couples tends to be dominated by gender stereotyping making a male partners historical game most of the glory Jodie managed to escape that mostly of first influence here is the domain name waiting both the names into one repeatedly emphasising at presentations and in interviews that Joan does the work and he only serves the coffee unquestionably also helps both artists to be recognised on an equal footing past maths paying respect to his partner scouting abilities shows has Kirk special thing coming with computers never faded and that is that it is a significant Force in Geordie since 2017 John has Kirk officially also creates solar works officially this recent work again reveals how fascinated John is by the intricacies of network systems and by how these systems manifest around us both in our personal sphere and beyond for example in Wi-Fi garden the built-in feature that allows mobile phones to be tracked easily is specialised on a webpage a Wi-Fi sniffer is attached to a household broom symbolising the way the background technology of smartphone sweeps privacy rights under the rug data of text phones is Visualized in pulsating colourful dots ironic keep picturing our vulnerability as a beautiful garden my favourite is her work q&q Eliza by necessity created in collaboration with quantum scientists since quantum computers are not accessible to me and mortals this first visual are peas made with quantum computers is a culmination of typical Hayes characteristics patient experimentation conceptual poetry humour and Marvel the work opens up opens with a picture of Schrodinger's cat with capital Q sides dancing over it and a conversation with a quantum computer becoming ever more gold below about quantum computers from quantum computing lifted from the net resound in machine speak then a deeper layer reveals an income prehensile Beck and system accompanied by The Incredible noise on some computers produce you aren't you breaking work technologically it is personal on top John Hayes cars in 8 love 14 cream has reached the ultimate in computing that on a quantum level the title q&q Liza refers to Liza the first child but but also harkens back to a Dutch TV series for children from the 70s and title to q&q which was a sort of teenage version of antonioni famous cult classic blow-up q&q trigger John Haynes Clerks first interest in technology q&q cool at once demystifies to quantum computer and pulls it into the realm of art and poetry there is no such thing as quantum supremacy here instead we see a machine grappling to learn and Express itself while it is pulled into the Artists poetic play with memory and media is 10 minutes here of course leave no room to fully disclose the full breadth of John Home Care Home sketch work which now contains nearly three decades of artistic practice I would therefore like to close with the remark about the significance of the lights we may see a reflection of how we are changing as a society when we compare the recognition of other artists to that of John I took more than 40 years of Solo are practised for for example stained stained to finally receive credit for her work she won the cigarette distinguished artist award in 2016 as a starting her solo career in 1975 I think John has Kirk being awarded for her work in digital art today after just 27 years is a sign of progress and a promise of good things to come",
    "state_event":"laudatio-2",
    "color":"eins",
    "assoc":"bosma",
    "start": 2310,
    "duration": 759
  },{
    "id":"59bab6ed-3eef-413e-88bd-b8b85d88128c",
    "uid":"iXn6wKsx4n9rqvOqAAE7",
    "username":"Joan Heemskerk",
    "usershort":"JH",
    "type":"message",
    "interim":"",
    "final":"everyone first thank you for coming here it's Friday the 13th and basically that always was a day to start coding and hacking all over the world so perfect it you're here it kind of nice first of all I have to thank you for this price and for all so as she has 18 set before I want to show you the work till and Q because it's her favourite it's also because the last time I had presentation about it I make it because I wasn't that little so I'd like to share my screen now quantum circuits software will make quantum computing more broadly accessible which basically c is two queues running around in it starts or quite simple what's interested in quantum Computing the first thing I noticed that was that there were a lot of hours and I couldn't have made this work made out of London think her group in and out somehow I thought experiment there is a cat in the room and I should have rings theories it could be dead or alive and so cool so could be my name is just like translate this transcript from John to Joan and vice versa so you never know if you're a 1 or 0 or everything in between so the cats in the background are basically not real cats they come from a database of artificial cats another words kids don't exist NS the peace is name Calisa which is like a parody on the name Elisa Elizabeth the first day I deposit urine test and if you don't know what the Turing test is a Turing test is basically if we see if we believe if a computer is human yes or no so in the background you basically on the bottom you so no see this words mangled and the moors get mangoes because we do that number benchmarking quantum computer DS4 actually",
    "state_event":"presentation-2",
    "color":"funf",
    "assoc":"heemskerk",
    "start":3093,
    "duration": 292

  },{
    "id":"b34daf88-7441-4efe-a64a-bf6b328fa3ab",
    "uid":"dUEcoYh0PG_tFyh5AAMj",
    "username":"Joan Heemskerk",
    "usershort":"JH",
    "type":"message",
    "interim":"",
    "final":"so high I managed to crash the system I hope you're all here didn't leave the page don't know why I pressed the system therapist so whatever saying that I found out about quantum computers is on the one hand they are the next future I don't know if there is a anyway there will be dis super Supremacy from which Google set ok if done it in 2020 we never know I quickly go forward to the next page turn the sound to hear and the programming is basically what's wrong with this one the song 32 is watching here and coronavirus the every time he asked when you get me I wanted to say no no no a couple of dates for yesterday the sounds like I'm the murderer picture of the black hole turn off the lights service stop doing the screen sharing now maybe a share my screen again have a look what's the internet now and maybe it out of curiosity maybe it's about what we're having to do so this is the internet now and actually you see our Pleasant cancel mouth nothing somewhere there if you saw man it's like all this little satellites surfing around nana where you are might be here has full of Internet cables anyway I think North rhine-westphalia must be some more here and it's above your head now it's the flock most of the satellites in our day of starving so I want see with this picture at internet ok but we have internet through exchange things and there is a whole new internet above your head which you don't see and might affect our future so think I've finished here",
    "state_event":"presentation-2",
    "color":"funf",
    "assoc":"heemskerk",
    "start": 3432,
    "duration": 327
  },{
    "id":"c9cd627e-4e52-4290-b6aa-d04737196805",
    "uid":"6wFqm-hBUo0sTQHMAADV",
    "username":"Anke Eckardt",
    "usershort":"AE",
    "type":"message",
    "interim":"",
    "final":"thank you Joan for this presentation I've got a question do you think change when quantum computing becomes a consumer technology maybe one day",
    "state_event":"dialogue-2",
    "color":"funf",
    "assoc":"eckardt",
    "start": 3781,
    "duration": 19
  },{
    "id":"6f5ea1d9-8b4b-4a43-99e9-004fb7a3cc71",
    "uid":"dUEcoYh0PG_tFyh5AAMj",
    "username":"Joan Heemskerk",
    "usershort":"JH",
    "type":"message",
    "interim":"",
    "final":"first of all I think quantum computing never will be consumer technology the reason I think that it's like we're now heading to quantum internet and it's all about it corruption and there is already an encryption to a satellites there is an encryption 22 lights and diamonds in the Netherlands I say literally Diamonds because they use that to get an entanglement between the different notes and if there will be a quantum consumer internet it will be about encryption it will be about I might use it is like being on the main frame bike in the 70s so the sound to hairdos the fridges in a quantum lap there also fridges and I make a hell of a lot of noise and you can't go there if you have any heart problem so maybe to yourself and you would look up to the main frame which you probably already do",
    "state_event":"dialogue-2",
    "color":"funf",
    "assoc":"heemskerk",
    "start": 3804,
    "duration": 92

  },{
    "id":"98e8773f-dc83-41b3-8796-c058bf19e77d",
    "uid":"-CAS08aatST_8ik2AACr",
    "state_event":"presentation-2",
    "username":"James",
    "usershort":"J",
    "type":"question",
    "interim":"",
    "final":"Will artificial intelligence ever make art?",
    "time":1652468994348,
    "start": 3904,
    "duration": .2
  },{
    "id":"00de45e3-10ca-4c07-902a-331eab164784",
    "uid":"dUEcoYh0PG_tFyh5AAMj",
    "username":"Joan Heemskerk",
    "usershort":"JH",
    "type":"message",
    "interim":"",
    "final":"wow that's a tough one it depends what you think what is art is if you consider artificial intelligence anyway during it with a i it will be a question of real human accepted this art",
    "state_event":"dialogue-2",
    "color":"funf",
    "assoc":"heemskerk",
    "start": 3904,
    "duration": 38
  },{
    "id":"78ebe2c2-501c-4104-8421-e94656bfc47d",
    "uid":"6wFqm-hBUo0sTQHMAADV",
    "username":"Anke Eckardt",
    "usershort":"AE",
    "type":"message",
    "interim":"",
    "final":"ok no I first have to digest all this input thank you very very much the last speaker I'm pleased to announce the exhibition of the two Award winners John Haynes Kirk and Davies delafuente Matthias let me see my pictures of the exhibition will be presented on the female artist of what website it will go online on 10th of June and run until the end of this year both artists are producing a new artistic work for this framework so it's my pleasure to know I would say shortly introduce you to these two works in her recent works never still have winter coat uses digitality as she said already to recreate memories I would say not from this side but knowing full well that this digital reconstructions are full of shifts of artefacts so to speak and that they dislocate reality also the case in her new work and titled Aviva and Billy the Specials starting point of the work is again in southern Spain it's the actual house of the artist grandmother name me her bookshelf Nevis uses the image and the concept and the real species of earthworms eating the way through the books in this bookshelf what the artist does is she reconstructs the tunnels of the woodworms as a 3D labyrinth she in largest them and expanse them into landscape 2 walkthrough keyword landscape also something you this already talked about the village from which this part of the artist family comes from is surrounded by this open cast mine that has been active for 5000 years you this already talked about it so I don't want to say too much basically several minerals like gold silver copper and Salford over the centuries maybe just one more detail at the beginning of the nineteenth century the area was administered by the British company called Rio Tinto Limited it's a company that pursuit maximum profit therefore they used techniques that were illegal even at that time techniques such as burning the excavated copper to separate it from the rest of the Earth so you can see so cold burning Hills what happens if you actually burnt copper on soil that contains sulphur is the production of acid rain in her work service addresses the wood worms as a species which is also in her region associated with death during the traditional silence a deathbed when someone diet in the village the sounds of woodworms become audible so in her piece the woodworms I've ever and Billy finally will become a plague people jump from one display to another they will jump out of the browser once you are in her peace and they will jump into your smartphone virtual augmented reality scratcher the woodworm Will Inherit your environment their ever you are they will be surrounded by the letters S and G these two letters are they needed you have to type them to complete the word passage with which one you will enter a warm hole lift you into the alien like landscape of the open cast mine deformed abandoned and strangely beautiful no I would like to invite you to make a change of perspective the winner of the main prize John Haynes Kirk will present a new piece on the website that is based on processes she is working on and she already talked about when I asked Joan last week what can you tell me about this work she gave the astonishing answer well I would like to suggest a different kind of Computing the work is called prototype think of it as a kind of fantasy a sentence about something that defines the nature of the digital that determines our way our way of human thinking and acting in digital context which is the distinction between 0 and 1 the construction of the whole digital structure into discrete States and one John Haynes Kirk presents another wishing I quote want to propose that there are more options in computing intermediate States in betweens but how could a system beyond 0 and 1 even be possible now we just talked about it shortly during the Q&A sunset the general idea of non-binary Computing instead of binary computing cannot be solved at the moment maybe in the future with quantum computing that's why the peace is called prototype it's a bit like a fake science it's a humorous fantasy prototype will be a generative piece it will appear as half text half image a selection of words will be used as input information these words are then translated into a hexadecimal system in Mathematics and Computing the hexadecimal system is a positional number system that uses 16 different symbols mostly 029 for the values 0 to 9 and a 2 f the letters for the values from 10 to 15 decimal numbers provide this at least one point of view and human friendly representation of binary coded values from there the artist will transform these numbers again in a heat system you can imagine this as a kind of heat map soft in 3D these numbers will become visual prototype you work by Joan will become complemented by an explanation by text that brings the coat to the foreground and with that I would actually like to enter this a what ceremony my and honest congratulations go to John Haynes Kirk and service delivery for receiving this award thank you both for your contributions this evening another one thank you to all the speakers at this ceremony tonight another thank you to the truly preliminary and the manger for the fantastic work last but not least thank you everybody here I could see your dad's moving for joining us tonight and once again warm invitation so from 10th of June on you will find the exhibition of John Holmes Kirk and never still have went a good deals on the website of the nav no friend Australia female artist what for digital art please pass by have a look yourself be surprised and for now I would like to say take care and goodnight",
    "state_event":"exhibition",
    "color":"funf",
    "assoc":"eckardt",
    "start": 3973,
    "duration": 704
  }];

  const [tLength, setTLength] = useState(0);
  
  // const ytBgRef = useRef(null);
  
  // const [mice, setMice] = useState([]); // todo: useRef?

  const schedule = [{
    time: "20:05",
    title: "Greeting",
    info:"held in German",
    duration: 5,
    speaker: "Isabel Pfeiffer-Poensgen",
    function: "State Minister of Culture and Science",
    section: "intro",
    chapter: 0
  },{
    time: "20:10",
    title: "Greeting",
    duration: 5,
    speaker: "Ursula Theißen",
    function: "Managing Director of the Frauenkulturbüro",
    section: "greeting-1",
    chapter: 1
  },{
    time: "20:14",
    title: "Greeting",
    duration: 5,
    speaker: "Prof. Diana McCarty",
    function: "Chair Jury, Board faces, Curator, author, researcher, lecturer in digital arts",
    section: "greeting-2",
    chapter: 2
  },{
    // headline: "Die Förderpreisträgerin Nieves de la Fuente Gutiérrez",
    time: "20:18",
    title: "Laudation Sponsorship Award",
    duration: 10,
    speaker: "Thomas Hawranke PhD",
    function: "artist, researcher, lecturer",
    section: "laudatio-1",
    chapter: 3
  },{
    time: "20:27",
    title: "Showcase",
    duration: 10,
    speaker: "Nieves de la Fuente Gutiérrez",
    function: "awardee",
    section: "presentation-1",
    chapter: 4
  },{
    time: "20:37",
    title: "Q+A",
    duration: 10,
    speaker: "",
    function: "",
    section: "dialogue-1",
    chapter: 5
  },{
    // headline: "Die Hauptpreisträgerin Joan Heemskerk",
    time: "20:43",
    title: "Laudation Main Price",
    duration: 10,
    speaker: "Josephine Bosma",
    function: "critic and theorist",
    section: "laudatio-2",
    chapter: 6
  },{
    time: "20:56",
    title: "Showcase",
    duration: 10,
    speaker: "Joan Heemskerk",
    function: "awardee",
    section: "presentation-2",
    chapter: 7
  },{
    time: "21:08",
    title: "Q+A",
    duration: 10,
    speaker: "",
    function: "",
    section: "dialogue-2",
    chapter: 8
  },{
    time: "21:11",
    title: "Announcement Exhibition",
    duration:5,
    speaker: "Anke Eckardt",
    function: "curator",
    section: "exhibition",
    chapter: 9
  }];

  const eventStateNames = {
    "pre-event": "Welcome",
    "intro": "Greeting",
    "greeting-1": "Greeting",
    "greeting-2": "Greeting",
    "laudatio-1": "Laudation Sponsorship Award",
    "presentation-1": "Showcase",
    "dialogue-1": "Q+A",
    // "quotes": "O-Töne aus dem Netzwerk",
    "laudatio-2": "Laudation Main Price",
    "presentation-2": "Showcase",
    "dialogue-2": "Q+A",
    "exhibition": "Announcement Exhibition",
    "post-event": "Post Event"
  };
  const eventStateSpeaker = {
    "pre-event": "",
    "intro": "Isabel Pfeiffer-Poensgen",
    "greeting-1": "Ursula Theissen",
    "greeting-2": "Diana McCarty",
    "laudatio-1": "Thomas Hawranke",
    "presentation-1": "Nieves de la Fuente Gutiérrez",
    "dialogue-1": "",
    // "quotes": "O-Töne aus dem Netzwerk",
    "laudatio-2": "Josephine Bosma",
    "presentation-2": "Joan Heemskerk",
    "dialogue-2": "",
    "exhibition": "Anke Eckardt",
    "post-event": "Thanks for coming!"
  };

  const eventStateThemes = {
    "pre-event": "white",
    "intro": "photo",
    "greeting-1": "blue",
    "greeting-2": "blue",
    "laudatio-1": "pink",
    "presentation-1": "dark",
    "dialogue-1": "pink",
    "laudatio-2": "purple",
    "presentation-2": "dark",
    "dialogue-2": "purple",
    "exhibition": "grey",
    "post-event": "white" 
  }


  const modalConfirm = () => {
    
    setModalVisible(0);

    setTimeout(() => {
      setModal(0);  
    }, 2000);

    
  }
  


  const setStateInView = (state) => {
    if(state !== 'generic' && state !== null && state !== stateInView){
      // console.log('setStateInView ' +state);
      _setStateInView(state);
    }
  }


const showAndPlayBgVideo = () => {
  console.log('showAndPlayBgVideo',progress);
  // ytBgPlayVideo();
  if(progress < 317){
    setYTplayState(true);
  }
};



  

const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const startTheHearts = () => {

  // console.log('startthehearts');
  let heartCount = 0;

  const interval = setInterval(() => {
    
    // console.log('startthehearts');
    heartCount += 1;

  var viewportwidth;
  var viewportheight;

  if (typeof window.innerWidth !== 'undefined')
  {
        viewportwidth = window.innerWidth;
        viewportheight = window.innerHeight;
  }
  else if (typeof document.documentElement !== 'undefined'
  && typeof document.documentElement.clientWidth !==
  'undefined' && document.documentElement.clientWidth !== 0)
  {
        viewportwidth = document.documentElement.clientWidth;
        viewportheight = document.documentElement.clientHeight;
  }
  else
  {
        viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
        viewportheight = document.getElementsByTagName('body')[0].clientHeight;
  }

  const hData = {
    id: 'h-'+Date.now(),
    x: Math.random()*viewportwidth+"px",
    y: Math.random()*viewportheight+"px",
    date: Date.now()
  };

  if(heartCount > 99){
    clearInterval(interval);
  }

  // setHeartList((list) => [...list.filter((item, index) => item.date+7000 > Date.now()),hData]);
  setHeartList((list) => [...list, hData]);
    
  }, 500);


}

const determineTIV = () => {
  
  var grpPrt = document.getElementsByClassName('grp-prt');
  let grpinVP = -1;

  for(var g = grpPrt.length-1; g >= 0; g--){
    if(isInViewport(grpPrt[g])){
      grpinVP = g;
      break;
    }
  }

    if(grpinVP > 0){
      if(grpPrt[grpinVP]){
        let state_ = grpPrt[grpinVP].getAttribute('data-state')
        setThemeInView(eventStateThemes[state_]);
        setStateInView(state_);
      }
    }

}

  
// player functionality

const handlePlayPause = () => {



  let action = playing ? 'pause' : 'play';

  if(action === 'pause'){
    // setYTplayState(false)
    setPlaying(false);
    setPlayingBg_(false);
  }else{
    if(progress < 317){
      // setYTplayState(false);
      setPlaying(false);
      setPlayingBg_(false); // bg video
    }else{
      setYTplayState(false);
      setPlayingBg_(false);
      setPlaying(false);
    }
  }

  // if(playerRef.current){
  //   setPlaying(!playing);
  //   // playerRef.current.
  // }

  if(videoBgRef.current){
    if(action === 'pause'){
      setPlaying(false);
    }else{
      if(progress < 317){
        setPlaying(true);
        setPlayingBg_(true); //bg video
        setYTplayState(true);
      }else{
        setPlaying(true);
        setYTplayState(false);
        setPlayingBg_(false);
      }
    }
  }
  
};

const setSection = (item) => {

  console.log('setsection')

  localStorage.setItem('kp-current-chapter', item.section);

  setEventState(item.section)

  // console.log(item);
  if(item.section !== 'intro'){
    setYTplayState(false);
    setPlayingBg_(false);
    if(videoBgRef.current)videoBgRef.current.seekTo(0);
  }else{
    if(videoBgRef.current)videoBgRef.current.seekTo(0);
    setYTplayState(true);
    if(playing) setPlayingBg_(true);
  }

  // audio
  if(playerRef.current){
    playerRef.current.seekTo(item.startText);
    // setPlaying(true);
  }


  setTimeout(() => {
  
  let refElem = document.getElementById('t-'+item.ref);
  if(refElem){
    refElem.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  }, 500);
  
  // theme

  setStateInView(item.section);
  if(eventStateThemes[item.section]){
  setThemeInView(eventStateThemes[item.section])
  }


};

  useEffect(() => {

    setSavedProgress(localStorage.getItem('kp-playback-position'));    
    console.log('on load. savedProgress: '+savedProgress);

    // if(savedProgress > 0){
    //   setProgress(savedProgress);
    // }

  },[]);

  useEffect(() => {
    
    if(transcript.length > tLength){
      determineTIV();
      setTLength(transcript.length);
    }

    let localChapter = localStorage.getItem('kp-current-chapter');
    // console.log('localChapter', localChapter)
    if(localChapter > 0){
      setSection(chapters.indexOf(localChapter));
    }
    // console.log(transcript)
  }, [transcript]) 
  
  useEffect(() => {

    if(eventState !== 'post-event'){
      return;
    }

    let kpWindow = document.getElementById('kp-mc')
   
    const onScroll = (ev) => {
      

      let y = kpWindow.scrollTop + window.innerHeight/2;
      
      if(eventState === 'post-event'){
        // console.log('scollr');
        var grpPrt = document.getElementsByClassName('grp-prt');
  
        let closest = null;
        let current = null;
        let dist = 0;
        for (var i = 0; i < grpPrt.length; i++) {
  
          current = grpPrt[i];
  
          let dist2 = Math.abs(y - current.offsetTop);
  
          if (closest === null || Math.abs(y - current.offsetTop) < Math.abs(y - closest.offsetTop)) {
            closest = current;
            dist = dist2;
          }
        }
        if(closest){
        if(closest.hasAttribute('data-state')){
        let state = closest.getAttribute('data-state');
        // console.log(state);
        if(state !== null && state !== '' && state !== undefined && state !== 'generic'){
         if(stateInView !== state){
           setStateInView(state);
           if(eventStateThemes[state]){
            setThemeInView(eventStateThemes[state])
           }
          //  console.log(state);
  
         }
        }
      }
      }
    
  }
     
      

  }
    // clean up code
    if(kpWindow) kpWindow.removeEventListener('scroll', onScroll);
    if(kpWindow) kpWindow.addEventListener('scroll', onScroll, { passive: true });
    return () => { if(kpWindow) kpWindow.removeEventListener('scroll', onScroll); }



  }, [eventState]);

  useLayoutEffect(() => {

    if(modal > 0) return;

    // TODO: offset interessant für blurstate von headline
    // console.log('stateInView: '+stateInView);
    let headline = document.getElementById('kp-headline-h1');
    if(headline) headline.classList.remove('fadeout');
    
    let headline2 = document.getElementById('kp-headline-h2');
    if(headline2) headline2.classList.remove('fadeout');
    

    setTimeout(() => {
      if(headline) headline.classList.add('fadeout');
      if(headline2) headline2.classList.add('fadeout');

    }, 500);
    // console.log(offset);

    console.log('useLayoutEffect ' +stateInView);
    if(stateInView !== 'intro'){
      setPlayingBg_(false);
    }

  }, [stateInView, eventState, modal]);

  useLayoutEffect(() => {

    // var viewportwidth;
    // var viewportheight;

    // if (typeof window.innerWidth !== 'undefined')
    // {
    //       viewportwidth = window.innerWidth;
    //       viewportheight = window.innerHeight;
    // }
    // else if (typeof document.documentElement !== 'undefined'
    // && typeof document.documentElement.clientWidth !==
    // 'undefined' && document.documentElement.clientWidth !== 0)
    // {
    //       viewportwidth = document.documentElement.clientWidth;
    //       viewportheight = document.documentElement.clientHeight;
    // }
    // else
    // {
    //       viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
    //       viewportheight = document.getElementsByTagName('body')[0].clientHeight;
    // }

    const mouseData = {
      x: mouse.pageX / document.body.scrollWidth,
      y: mouse.pageY / document.body.scrollHeight
    }

    // drag interaction
    if(dragStart > 0){
      // console.log(mouse.clientX,dragStart)
      // map dragStart to current progress

      if(mouse.isDown === false){
        setDragStart(-1);
        setHandleTitle('drag me!');
        
        if(setPlayingAtDragStart){
          if(progress < 317) setPlayingBg_(true);
          setPlaying(true);
        }else{
          setPlayingBg_(false);
        }
      }

      let bar = document.getElementById('kp-progress-bar');
      let barLen = bar.offsetWidth;
      let barLeft = bar.offsetLeft;

      let dragVal = ((mouse.clientX - barLeft)/barLen);
      if(dragVal > 1) dragVal = 1;
      if(dragVal < 0) dragVal = 0;

      var date = new Date(null);
      date.setSeconds(dragVal*duration+72300); // specify value for SECONDS here
      var result = date.toISOString().substr(11, 8);
      setHandleTitle(result);

      // console.log((mouse.clientX - dragStart)/barLen);
      setProgress(dragVal*duration);

      playerRef.current.seekTo(dragVal*duration);

      if(dragVal*duration < 317){
        if(videoBgRef.current){
         videoBgRef.current.seekTo(dragVal*duration);
        }
        setYTplayState(true);
        
      }else{
        setYTplayState(false);
        setPlayingBg_(false)
      }
      
    }else if(dragStart === -1){
      setDragStart(0);
      if(setPlayingAtDragStart){
        setPlaying(true);
        setPlayingBg_(true);
      }else{
        setPlayingBg_(false);
      }
      // setPlaying(true);
    }

  }, [mouse,dragStart]);


  useEffect(() => {
   
    for (let i = 0; i < triggers.length; i++) {

      if(triggers[i].start < progress && triggers[i].end > progress){
        
        setOverlayImage(triggers[i].ref);
        setOverlay('true');    

        if(overlayImage !== triggers[i].ref){
          setOverlayImage(triggers[i].ref);
          setOverlay('true');    
        }

      }else if(triggers[i].start < progress && triggers[i].end < progress){ // ended
        
        if(overlayImage === triggers[i].ref){
          setOverlay('false');    
          // console.log('overlay false '+triggers[i].ref)
          if(videoRef.current) videoRef.current.seekTo(0);
        }
      
    }else{
      if(overlayImage === triggers[i].ref){
        setOverlay('false');    
        // console.log('overlay false '+triggers[i].ref)
        if(videoRef.current) videoRef.current.seekTo(0);
      }
    }

  }

  let kpw = document.getElementById('kp-mc');
    if(kpw){
      if(kpw.scrollHeight > kpw.clientHeight){
        messagesEndRef.current?.scrollIntoView({ behavior: "auto" })
      }
    }

    for (let j = 0; j < chapters.length; j++) {
      if(progress >= chapters[j].start && progress < (chapters[j].start+chapters[j].duration)){
        // set section if necessary
        if(eventState !== chapters[j].section){ setEventState(chapters[j].section) }

        // if within intro, seekTo video
        if(j === 0 && mouse.isDown && dragStart > 0){ // pfeiffer-poensgen
          console.log('video at L1391');
        }else if(j === 7 && mouse.isDown && dragStart > 0){ // joan
          if(videoRef.current){
            if(progress > 3179 && progress < 3390){
              setOverlay('true');
              setVideoUrl("https://storage.googleapis.com/kp22/heemskerk/joan-one-2000kbit.mp4");
              videoRef.current.seekTo(progress-3179)
            }else if(progress < 3179 || (progress > 3390 && progress < 3423)){
              setOverlay('false');
            }else if(progress > 3423 && progress < 3616){ // joan two
              setVideoUrl("https://storage.googleapis.com/kp22/heemskerk/joan-two-2000kbit.mp4");
              setOverlay('true');
              videoRef.current.seekTo(progress-3423)
            }else if(progress > 3616 && progress < 3657.82){
              setOverlay('false');
            }else if(progress > 3657.82 && progress < 3757.33){
              setVideoUrl("https://storage.googleapis.com/kp22/heemskerk/joan-three.mp4");
              setOverlay('true');
              videoRef.current.seekTo(progress-3657.82)
            }else if(progress > 3757.33){
              setOverlay('false');
            }            
          }

          }else if(j === 4 && mouse.isDown && dragStart > 0){ // nieves

            if(videoRef.current){

              if(progress > 1363.85 && progress < 1902.35){
                setOverlay('true');
                setVideoUrl("https://storage.googleapis.com/kp22/ndlfg/nieves-01_1.mp4");
                videoRef.current.seekTo(progress-1363.85)
              }else if(progress < 1363.85){
                setOverlay('false');
              }else if(progress > 1902.35){
                setOverlay('false');
              }
            }
        }
      }
    }

    for(let j = 0; j < hearts.length; j++){
      if( (progress-hearts[j]) > 0 && (progress-hearts[j]) < 0.25){
        // console.log('heart '+j);

        let xRand = Math.random() * 40 - 20

        let hRef = document.getElementById('kp-heart-ref');
        let x = hRef.offsetLeft + hRef.clientWidth/2 + xRand;
        let y = hRef.offsetTop-60;
        
        const hData = {
          id: 'h-'+Date.now(),
          x: x+"px",
          y: y+"px",
          date: Date.now()
        };
        setHeartList((list) => [...list.filter((item, index) => item.date+7000 > Date.now()),hData]);

      }
    }

    var date = new Date(null);
    date.setSeconds(progress+72300); // specify value for SECONDS here
    var result = date.toISOString().substr(11, 8);
    setHandleTitle(result);

    // save playback position every 5 seconds
    if(progress%5 < 0.251 && progress > 4){
      localStorage.setItem('kp-playback-position',Math.floor(progress));
      // console.log('every 5 = ',progress);
    }

    // hide minister video after video
    if(progress > 317 && progress-317 < 0.251){
      setYTplayState(false);
    }else if(progress > 317){
      setPlayingBg_(false);
      setPlayingBg(false);

  }

}, [progress, overlay]);

  return (
    <div id="kp-window" className={'t-black tiv-' +themeInView+ ' siv-' +stateInView+ ' t-'+eventStateThemes[eventState]+' overlay-'+overlay+' bgv-'+(eventState === 'intro') + ' s-'+eventState+ ' r-'+role}>

    <div className="bg-yt-container">
    <div className={"bg-yt" + (ytPlayState ? ' playing' : '')}>
        
  <ReactPlayer 
  ref={videoBgRef}
  playing={playingBg} 
  // url="https://storage.googleapis.com/kp22/kp-audio-96kbps.mp3"
  // url="./ppoensgen/ppoensgen-leved.mp4"
  url="https://storage.googleapis.com/kp22/ppoensgen/ppoensgen-leveled-4000kbit.mp4"
  width='177.78vh'
  height='100vh'
  muted={progress > 317 ? true : false}
  progressInterval={1000}
  onReady={() => { if(progress > 317){ setPlayingBg_(false) }}}
  // onStart={() => showAndPlayBgVideo()}
  // onPlay={() => console.log('onPlay')}
  // onProgress={(d) => setVideoBgProgress(d.playedSeconds)}
  // onDuration={(d) => setDuration(d)}
  // onPause
  // onSeek
  // onEnded
  />

    </div> 
    </div>
      {/* ) : null }  */}

    <div className="log-window">
        
      { (eventState !== 'pre-event') ?
        <div className="chat-body">
        <div id="kp-mc" className="message-container">

          {
          transcript.map((msg, index, transcript) => {

            if(progress < msg.start) return; // only show ones within progress.

            let msgDuration = msg.duration;
            let msgChars = msg.final.length;
            let whereAreWe = (progress-msg.start)/msgDuration; // where are we within the transcript?

            // output right number of characters according to process
            let howMuchIsTheFish = Math.floor(msgChars*whereAreWe);
            let msgNow = msg.final.substring(0, howMuchIsTheFish)

            let output = "[" + msg.username + "] " + msgNow;

            if(msgNow.length < 1) return;
            
            let outputSplit = output.match(/.{1,80}/g);
            // let lineCount = outputSplit.length;
            if(msg.final.length + msg.interim.length === 0){
              return null;
            }
            if(msg.type === 'question'){
              // outputSplit.unshift(" ")
              outputSplit.push(" ");
            }else if(msg.username === 'Bot'){
                return null;
            }
            
            return (
              <div key={index} id={'t-'+msg.id} data-state={msg.state_event} className={'grp-prt state-' + msg.state_event + ' ' + msg.style + ' ' + (transcript.length-1 === index ? ' last' : '') + ' ' + (index%2 === 0 ? 'odd' : '') + ' ' + msg.type + ' c-'+msg.color}>
              
              <div className="grp">
                    
                    <div className="g-n">
                      
                      <div className={"avatar " + ((usershort.length > 0 && usershort.length > 0 && outputSplit.length > 1 && index === transcript.length-1) ? 'visible' : null)+ ' bg-'+msg.color } title={msg.username}>{msg.usershort}</div>
                    </div>
                    <div className="g-c">
                      {/* <span className="tag">{msg.style}</span> */}
                      <span className="tag">{msg.state_event}|{msg.color}</span>
                      { 
                        outputSplit.map((grp, i, outputSplit) => {

                        var result = grp;

                        result = result.replace(/[[]/g, '<strong>').replace(/[\]]/g, '</strong>');

                        if(result[0] === '.'){
                          result = result.substring(1);
                        }
                        if(result[0] === ','){
                          result = result.substring(1);
                        }
                        if(result[0] === ' '){
                          result = result.substring(1);
                        }

                        return(
                          <div key={i}>
                          <div className={'g-line gl-' + i } dangerouslySetInnerHTML={{__html: result}}/>
                          </div>
                          )
                        })
                      }
                    </div>
              </div>
              </div>
            );
          })
        }
        <div className="kp-endref" ref={messagesEndRef}>&nbsp;</div>
        </div> 
        </div> : null
      }
  
    </div>

    <div className="kp-headline">
        { eventState !== 'pre-event' && eventState !== 'post-event' ? <><h1 id="kp-headline-h1" className={eventState+ ' fadeout'}>{eventStateNames[eventState]}</h1>{eventStateSpeaker[eventState] ? <h2 id="kp-headline-h2" className={eventState+ ' fadeout'}>{eventStateSpeaker[eventState]}</h2>: ''}</> : null }
        { eventState === 'post-event' && stateInView ? <><h1 id="kp-headline-h1" className={stateInView+ ' fadeout'}>{eventStateNames[stateInView]}</h1>{eventStateSpeaker[stateInView] ? <h2 id="kp-headline-h2" className={stateInView+ ' fadeout'}>{eventStateSpeaker[stateInView]}</h2>: ''}</> : null }
        
    </div>

    <div id="kp-gui">
      <div id="kp-head" className={'tiv-' +themeInView +' t-'+eventStateThemes[eventState]+' s-'+eventState}>
        <h1>Künstlerinnenpreis NRW 2022</h1>
             {/* <div className="kp-progress-time"><input value={progress} onChange={(e) => {setProgress(e.target.value)}}/> {dragStart} / {playing ? 'playing' : 'not playing'}</div> */}
      </div>

      <div className="hidden">
      <ReactPlayer 
     
      ref={playerRef}
      playing={playing}
      // url="https://storage.googleapis.com/kp22/kp-audio-96kbps.mp3"
      url="https://storage.googleapis.com/kp22/kp-audio-02-96kbps.mp3"
      width='100%'
      height='100%'
      progressInterval={250}
      // onReady={() => { if(playerRef.current){ playerRef.current.seekTo(savedProgress); } }}
      onStart={() => showAndPlayBgVideo()}
      // onPlay={() => console.log('onPlay')}
      onProgress={(d) => setProgress(d.playedSeconds)}
      onDuration={(d) => setDuration(d)}
      // onPause
      // onSeek
      onEnded = {(d) => {setModal(2); setModalVisible(1); startTheHearts()}}
      />
      </div>

      <div className={"kp-panel panel-functions"}>
        <div className="kp-play" id="kp-heart-ref">
          <button onClick={() => handlePlayPause()}>{playing ? 'pause' : 'play'}
          </button>
      </div>

      <div id="kp-progress-bar" className="kp-progress">

        <div className="kp-chapters">
        {
          chapters.map((item, index) => {
            return (
              <div key={index} style={{ 'width': item.duration/duration*100+'%' }} data-section={item.section} data-start={item.start} className={'t-'+eventStateThemes[item.section]} onClick={() => setSection(item)}>
                &nbsp;
              </div>
            )
          })
        }
        </div>

        <div className="kp-handle" 
        style={{'left': progress/duration*75+'vw' }} 
        onDragStart={() => console.log('drag handle')}
        onMouseDown={(e) => { setDragStart(e.clientX); setPlayingAtDragStart(playing); setPlaying(false); setPlayingBg_(false); } }
        onMouseUp ={(e) => {setDragStart(-1); }}
        data-title={handleTitle}
        ></div>
      
      </div>

        <button onClick={() => setScheduleVisible(!scheduleVisible)} className={scheduleVisible ? 'active' : ''}>schedule</button>        

      </div>

    </div>
      
      <div className={"overlay overlay-"+overlay+" overlay-type-"+inlineImages[overlayImage].type }>
      
      { inlineImages[overlayImage].type === 'image' ?
        <div className={"kp-inline-image"+ (overlay === 'true' ? ' visible' : '')}>
          {inlineImages[overlayImage] ? (
          <img src={inlineImages[overlayImage].url} alt={inlineImages[overlayImage].titles}/>
          ) : null }
        </div>
        : <>
  <ReactPlayer 
  ref={videoRef}
  playing={playing}
  // url="https://storage.googleapis.com/kp22/kp-audio-96kbps.mp3"
  url={videoUrl}
  width='80vw'
  height='45vw'
  muted ={true}
  progressInterval={1000}
  // onReady={() => console.log('onready')}
  // onStart={() => showAndPlayBgVideo()}
  // onPlay={() => console.log('onPlay')}
  // onProgress={(d) => setVideoProgress(d.playedSeconds)}
  // onDuration={(d) => setDuration(d)}
  // onPause
  // onSeek
  // onEnded

  />
</>
      }
      </div>

  <div className="kp-schedule-container">
    <div className={'kp-schedule '+ (scheduleVisible ? 'visible' : '')}>
      <div className="kp-schedule-body">
      <div className="panel-schedule">
              <table>
                <thead>
                  <tr>
                  <th>time</th>
                  <th>title</th>
                  <th>speaker</th>
                  </tr>
                </thead>
                <tbody>
              {
                schedule.map((item, index) => {
                  return (
                    <tr key={index} className={stateInView === item.section ? 'active' : ''} onClick={() => setSection(chapters[item.chapter])}>
                      <td>{item.time}</td>
                      <td className="td-title"><strong>{item.title}</strong><span>{item.info}</span></td>
                      <td><strong>{item.speaker}</strong>{item.function}</td>
                    </tr>
                  )
                })
              }
              </tbody>
              </table>
            </div>  
      </div>
    </div>
  </div>

  <div className={"kp-btn-play-big" + (playing ? ' playing' : '')}>
    <button onClick={() => handlePlayPause()}>Play</button>
  </div>

      

  { modal > 0 ? 
<div className={"kp-modal-container " + (modalVisible ? 'visible' : '') + " modal-"+modal}>

  <div className="kp-modal">
    <div className="kp-modal-head">
      <h1>Künstlerinnenpreis NRW 2022</h1>
    </div>
    <div className="kp-modal-body">
      <div dangerouslySetInnerHTML={{__html: modalText[modal]}}></div>
      { modal === 1 ?
      (<div className="btn-group">
      <button className="btn-modal" onClick={modalConfirm}>to the event</button>
      </div>) : null
      }
    </div>
  </div>
</div>
: null }

          <div id="kp-heartbox">
          { heartList.map((heart, index) => {

            return (
              <span key={index} id={heart.id} data-date={heart.date} className="kp-rs" style={
                {
                  'left': heart.x,
                  'top': heart.y
                }
              }><svg x="0px" y="0px" viewBox="0 0 72 64">
              <polygon className="st0" points="8,32 8,16 16,16 16,8 32,8 32,16 40,16 40,8 56,8 56,16 64,16 64,32 56,32 56,40 48,40 48,48 40,48 
                40,56 32,56 32,48 24,48 24,40 16,40 16,32 "/>
              </svg></span>
              
            );
          })
          }

          </div>
    </div>
  );
}

export default Chat;  